'use client';

import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type Context = {
  setTextarea: Dispatch<SetStateAction<string>>;
  textarea: string;
};

const TextareasContext = createContext<Context | null>(null);

interface Props {
  children: ReactNode;
}

const TextareasProvider = ({ children }: Props) => {
  const [textarea, setTextarea] = useState('');

  const value = { textarea, setTextarea };

  return (
    <TextareasContext.Provider value={value}>
      {children}
    </TextareasContext.Provider>
  );
};

function useTextareas() {
  const context = useContext(TextareasContext);
  if (!context) throw new Error('useTextareas requires a context!');

  return context;
}

export { TextareasProvider, useTextareas };
